// extracted by mini-css-extract-plugin
module.exports = {"page":"Layout_page__3uP2v","main":"Layout_main__3OBIG","header_placeholder":"Layout_header_placeholder__3Wc7E","header":"Layout_header__1V-LV"};